!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/api-types"), require("@driftt/tide-modal"), require("react-redux"), require("spacetime"), require("@driftt/web-auth"), require("axios"), require("qs"), require("swr"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "@driftt/api-types", "@driftt/tide-modal", "react-redux", "spacetime", "@driftt/web-auth", "axios", "qs", "swr"], t);else {
    var r = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/api-types"), require("@driftt/tide-modal"), require("react-redux"), require("spacetime"), require("@driftt/web-auth"), require("axios"), require("qs"), require("swr")) : t(e.react, e["@driftt/tide-core"], e.ramda, e["@driftt/api-types"], e["@driftt/tide-modal"], e["react-redux"], e.spacetime, e["@driftt/web-auth"], e.axios, e.qs, e.swr);

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t, r, n, o, a, i, l, u, s, c) {
  return function (e) {
    var t = {};

    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        __webpack_require__.d(r, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 82);
  }({
    0: function _(t, r) {
      t.exports = e;
    },
    1: function _(e, r) {
      e.exports = t;
    },
    11: function _(e, t, r) {
      "use strict";

      function _arrayLikeToArray(e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var r = 0, n = new Array(t); r < t; r++) {
          n[r] = e[r];
        }

        return n;
      }

      r.d(t, "a", function () {
        return _arrayLikeToArray;
      });
    },
    13: function _(e, t, r) {
      "use strict";

      e.exports = function (e) {
        var t = [];
        return t.toString = function toString() {
          return this.map(function (t) {
            var r = function cssWithMappingToString(e, t) {
              var r = e[1] || "",
                  n = e[3];
              if (!n) return r;

              if (t && "function" === typeof btoa) {
                var o = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(n),
                    a = n.sources.map(function (e) {
                  return "/*# sourceURL=" + n.sourceRoot + e + " */";
                });

                return [r].concat(a).concat([o]).join("\n");
              }

              return [r].join("\n");
            }(t, e);

            return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
          }).join("");
        }, t.i = function (e, r) {
          "string" === typeof e && (e = [[null, e, ""]]);

          for (var n = {}, o = 0; o < this.length; o++) {
            var a = this[o][0];
            null != a && (n[a] = !0);
          }

          for (o = 0; o < e.length; o++) {
            var i = e[o];
            null != i[0] && n[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), t.push(i));
          }
        }, t;
      };
    },
    14: function _(e, t, r) {
      "use strict";

      var n = {},
          o = function isOldIE() {
        var e;
        return function memorize() {
          return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
        };
      }(),
          a = function getTarget() {
        var e = {};
        return function memorize(t) {
          if ("undefined" === typeof e[t]) {
            var r = document.querySelector(t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[t] = r;
          }

          return e[t];
        };
      }();

      function listToStyles(e, t) {
        for (var r = [], n = {}, o = 0; o < e.length; o++) {
          var a = e[o],
              i = t.base ? a[0] + t.base : a[0],
              l = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
          n[i] ? n[i].parts.push(l) : r.push(n[i] = {
            id: i,
            parts: [l]
          });
        }

        return r;
      }

      function addStylesToDom(e, t) {
        for (var r = 0; r < e.length; r++) {
          var o = e[r],
              a = n[o.id],
              i = 0;

          if (a) {
            for (a.refs++; i < a.parts.length; i++) {
              a.parts[i](o.parts[i]);
            }

            for (; i < o.parts.length; i++) {
              a.parts.push(addStyle(o.parts[i], t));
            }
          } else {
            for (var l = []; i < o.parts.length; i++) {
              l.push(addStyle(o.parts[i], t));
            }

            n[o.id] = {
              id: o.id,
              refs: 1,
              parts: l
            };
          }
        }
      }

      function insertStyleElement(e) {
        var t = document.createElement("style");

        if ("undefined" === typeof e.attributes.nonce) {
          var n = r.nc;
          n && (e.attributes.nonce = n);
        }

        if (Object.keys(e.attributes).forEach(function (r) {
          t.setAttribute(r, e.attributes[r]);
        }), "function" === typeof e.insert) e.insert(t);else {
          var o = a(e.insert || "head");
          if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          o.appendChild(t);
        }
        return t;
      }

      var i = function replaceText() {
        var e = [];
        return function replace(t, r) {
          return e[t] = r, e.filter(Boolean).join("\n");
        };
      }();

      function applyToSingletonTag(e, t, r, n) {
        var o = r ? "" : n.css;
        if (e.styleSheet) e.styleSheet.cssText = i(t, o);else {
          var a = document.createTextNode(o),
              l = e.childNodes;
          l[t] && e.removeChild(l[t]), l.length ? e.insertBefore(a, l[t]) : e.appendChild(a);
        }
      }

      var l = null,
          u = 0;

      function addStyle(e, t) {
        var r, n, o;

        if (t.singleton) {
          var a = u++;
          r = l || (l = insertStyleElement(t)), n = applyToSingletonTag.bind(null, r, a, !1), o = applyToSingletonTag.bind(null, r, a, !0);
        } else r = insertStyleElement(t), n = function applyToTag(e, t, r) {
          var n = r.css,
              o = r.media,
              a = r.sourceMap;
          if (o && e.setAttribute("media", o), a && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
            for (; e.firstChild;) {
              e.removeChild(e.firstChild);
            }

            e.appendChild(document.createTextNode(n));
          }
        }.bind(null, r, t), o = function remove() {
          !function removeStyleElement(e) {
            if (null === e.parentNode) return !1;
            e.parentNode.removeChild(e);
          }(r);
        };

        return n(e), function updateStyle(t) {
          if (t) {
            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
            n(e = t);
          } else o();
        };
      }

      e.exports = function (e, t) {
        (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = o());
        var r = listToStyles(e, t);
        return addStylesToDom(r, t), function update(e) {
          for (var o = [], a = 0; a < r.length; a++) {
            var i = r[a],
                l = n[i.id];
            l && (l.refs--, o.push(l));
          }

          e && addStylesToDom(listToStyles(e, t), t);

          for (var u = 0; u < o.length; u++) {
            var s = o[u];

            if (0 === s.refs) {
              for (var c = 0; c < s.parts.length; c++) {
                s.parts[c]();
              }

              delete n[s.id];
            }
          }
        };
      };
    },
    141: function _(e, t, r) {
      "use strict";

      r.r(t);

      var n = r(8),
          o = r(0),
          a = r.n(o),
          i = a.a.createContext({
        playbook: void 0,
        activeVersionTimestamp: NaN,
        isViewingOlderVersion: !1,
        onSelectPlaybookVersion: function onSelectPlaybookVersion() {},
        onRevertToPlaybook: function onRevertToPlaybook() {},
        onCancelPreview: function onCancelPreview() {}
      }),
          l = r(5),
          u = r(1),
          s = r(2),
          c = r(17),
          d = r(24),
          f = r.n(d),
          p = r(50),
          y = function ConfirmationModal(e) {
        var t = e.open,
            r = e.onClose,
            o = e.onConfirm;
        return a.a.createElement(n.Modal, {
          size: "small",
          open: t,
          onClose: r
        }, a.a.createElement(n.ModalTitle, null, "Restore a playbook?"), a.a.createElement(n.ModalBody, null, "Are you sure you want to restore this playbook? All changes from this point onward will be lost."), a.a.createElement(n.ModalFooter, null, a.a.createElement(u.Button, {
          onClick: o
        }, "Restore"), a.a.createElement(u.Button, {
          onClick: r,
          type: "tertiary",
          style: {
            marginLeft: 8
          }
        }, "Cancel")));
      },
          b = r(48),
          m = r.n(b),
          _ = function HistoryItem(e) {
        var t,
            r,
            d = e.version,
            b = e.isCurrentVersion,
            _ = Object(o.useState)(!1),
            v = Object(l.a)(_, 2),
            h = v[0],
            g = v[1],
            T = function usePlaybookHistoryModalContext() {
          return a.a.useContext(i);
        }(),
            k = T.activeVersionTimestamp,
            A = T.isViewingOlderVersion,
            O = T.onRevertToPlaybook,
            E = T.onSelectPlaybookVersion,
            P = T.onCancelPreview,
            S = T.playbook,
            j = T.readonly,
            w = Object(n.useCloseModal)(),
            I = Object(c.useSelector)(s.pathOr([], ["org", "users"])).find(function (e) {
          return e.id === d.playbook.updatedAuthorId;
        }),
            C = null !== (t = null !== (r = null === I || void 0 === I ? void 0 : I.name) && void 0 !== r ? r : null === I || void 0 === I ? void 0 : I.email) && void 0 !== t ? t : "a teammate",
            x = d.createdTimestamp === k,
            B = f()(d.createdTimestamp).unixFmt("MM/dd/yy 'at' h:mm a"),
            M = function renderPreviewButton() {
          if (!j && x) return a.a.createElement("em", {
            className: m.a.historyItemAction
          }, "Viewing");
          var e = {};

          if (j) {
            var t = Object(p.getPlaybookEditorUrlPath)(S, p.PlaybookEditorUrlSubPath.BOT_FLOW);
            x || (t += "?versionAt=".concat(d.createdTimestamp)), e.target = "_blank", e.onClick = w, e.href = t;
          } else e.onClick = function () {
            return E(d);
          };

          return a.a.createElement(u.Button, Object.assign({
            size: "small",
            type: "tertiary",
            className: m.a.historyItemAction
          }, e), "View");
        };

        return a.a.createElement(a.a.Fragment, null, a.a.createElement("div", {
          className: m.a.historyItem
        }, a.a.createElement("div", null, a.a.createElement(u.Strong, null, "Published on ", B), a.a.createElement(u.P, {
          className: m.a.historyItemByline
        }, "by ", C)), a.a.createElement("div", null, function renderControls() {
          return j ? M() : b ? function renderReturnToCurrentVersionButton() {
            return A ? a.a.createElement(u.Button, {
              type: "tertiary",
              size: "small",
              onClick: P
            }, "Back to current version") : a.a.createElement("em", null, "Current version");
          }() : a.a.createElement(a.a.Fragment, null, function renderRevertButton() {
            return a.a.createElement(a.a.Fragment, null, a.a.createElement(u.Button, {
              size: "small",
              type: "tertiary",
              className: m.a.historyItemAction,
              onClick: function onClick() {
                return g(!0);
              }
            }, "Restore"), a.a.createElement(y, {
              open: h,
              onClose: function onClose() {
                return g(!1);
              },
              onConfirm: function onConfirm() {
                O(d.playbook), g(!1);
              }
            }));
          }(), " ", M());
        }())));
      },
          v = function useOnScreen(e) {
        var t = Object(o.useState)(!1),
            r = Object(l.a)(t, 2),
            n = r[0],
            a = r[1];
        return Object(o.useEffect)(function () {
          var t = new IntersectionObserver(function (e) {
            var t = Object(l.a)(e, 1)[0];
            return a(t.isIntersecting);
          });
          return e.current && t.observe(e.current), function () {
            t.disconnect();
          };
        }), n;
      },
          h = r(54),
          g = function HistoryPage(e) {
        var t = e.playbookId,
            r = e.lastCreatedTimestamp,
            n = Object(o.useRef)(null),
            i = v(n),
            u = Object(o.useState)(!1),
            s = Object(l.a)(u, 2),
            c = s[0],
            d = s[1],
            f = Object(h.default)(t, r).data;
        if (Object(o.useEffect)(function () {
          i && d(!0);
        }, [i]), !f) return null;
        var p = c && !!f.length;
        return a.a.createElement(a.a.Fragment, null, f.map(function (e) {
          return a.a.createElement(_, {
            key: e.createdTimestamp,
            version: e
          });
        }), p && a.a.createElement(HistoryPage, {
          playbookId: t,
          lastCreatedTimestamp: f.slice(-1)[0].createdTimestamp
        }), a.a.createElement("div", {
          ref: n
        }));
      };

      t.default = function PlaybookHistoryModal(e) {
        var t = e.open,
            r = e.onClose,
            o = e.publishedPlaybook,
            l = e.activePlaybook,
            u = e.readonly,
            s = e.onSelectPlaybookVersion,
            c = void 0 === s ? function () {} : s,
            d = e.onRevertToPlaybook,
            f = void 0 === d ? function () {} : d,
            p = e.onCancelPreview,
            y = void 0 === p ? function () {} : p,
            b = null !== l && void 0 !== l ? l : o,
            m = {
          playbook: o,
          createdTimestamp: o.updatedAt,
          retiredTimestamp: NaN
        },
            v = {
          isViewingOlderVersion: o.updatedAt !== b.updatedAt,
          activeVersionTimestamp: b.updatedAt,
          playbook: o,
          onSelectPlaybookVersion: c,
          onRevertToPlaybook: f,
          onCancelPreview: y,
          readonly: u
        };
        return a.a.createElement(n.Modal, {
          open: t,
          onClose: r,
          size: "small"
        }, a.a.createElement(n.ModalTitle, null, "Version history"), a.a.createElement(n.ModalBody, null, a.a.createElement(i.Provider, {
          value: v
        }, a.a.createElement(_, {
          version: m,
          isCurrentVersion: !0
        }), a.a.createElement(g, {
          playbookId: o.id
        }))));
      };
    },
    16: function _(e, t, r) {
      "use strict";

      r.d(t, "a", function () {
        return _unsupportedIterableToArray;
      });
      var n = r(11);

      function _unsupportedIterableToArray(e, t) {
        if (e) {
          if ("string" === typeof e) return Object(n.a)(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Object(n.a)(e, t) : void 0;
        }
      }
    },
    17: function _(e, t) {
      e.exports = a;
    },
    18: function _(e, t, r) {
      "use strict";

      var n = r(7),
          o = {
        QA: {},
        EU: {},
        US: {}
      };
      t.a = Object(n.a)(Object(n.a)({}, window.DRIFT_CONFIG || {}), o[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]);
    },
    2: function _(e, t) {
      e.exports = r;
    },
    22: function _(e, t, r) {
      "use strict";

      r.d(t, "b", function () {
        return c;
      }), r.d(t, "a", function () {
        return d;
      }), r.d(t, "d", function () {
        return f;
      }), r.d(t, "c", function () {
        return p;
      });
      var n = r(29),
          o = r(30),
          a = r.n(o),
          i = r(31),
          l = r.n(i),
          u = r(18);
      a.a.defaults.headers.post["Content-Type"] = "application/json";

      var s = function createApiClient(e) {
        return Object(n.createAuthedHttpClient)({
          baseConfig: {
            baseURL: e,
            paramsSerializer: function paramsSerializer(e) {
              return l.a.stringify(e, {
                arrayFormat: "repeat"
              });
            }
          }
        });
      },
          c = s(u.a.CUSTOMER_API),
          d = s(u.a.CONVERSATION_API),
          f = s(u.a.PLAYBOOK_REUSABILITY_API),
          p = s(u.a.MEETINGS_API);
    },
    24: function _(e, t) {
      e.exports = i;
    },
    26: function _(e, t, r) {
      "use strict";

      var n = r(11);
      var o = r(16);

      function _toConsumableArray(e) {
        return function _arrayWithoutHoles(e) {
          if (Array.isArray(e)) return Object(n.a)(e);
        }(e) || function _iterableToArray(e) {
          if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
        }(e) || Object(o.a)(e) || function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      r.d(t, "a", function () {
        return _toConsumableArray;
      });
    },
    29: function _(e, t) {
      e.exports = l;
    },
    30: function _(e, t) {
      e.exports = u;
    },
    31: function _(e, t) {
      e.exports = s;
    },
    32: function _(e, t, r) {
      "use strict";

      r.r(t);
      var n = r(26),
          o = r(4),
          a = [].concat(Object(n.a)(Object.values(o.PlaybookEditorTypes)), [o.PlaybookReportType.FORM_SUBMISSION_FAST_LANE]),
          i = Object.values(o.PlaybookMigratedTypes),
          l = Object.values(o.PlaybookMarketplaceWebTypes),
          u = Object.values(o.PlaybookChatTypes),
          s = [o.PlaybookReportType.ENTERPRISE_BOT],
          c = Object.values(o.PlaybookFastlaneTypes),
          d = [o.PlaybookReportType.MEETING_BOOKING_BOT],
          f = [o.PlaybookReportType.EMAIL_BOTS_V2],
          p = [].concat(Object(n.a)(Object.values(o.PlaybookEmailTypes)), [o.PlaybookReportType.ABANDONED_BOOK_A_MEETING, o.PlaybookReportType.VSB_DEFAULT_PLAYBOOK]);
      r.d(t, "isFastlanePlaybook", function () {
        return b;
      }), r.d(t, "isChatPlaybook", function () {
        return m;
      }), r.d(t, "isAIPlaybook", function () {
        return _;
      }), r.d(t, "isEmailPlaybook", function () {
        return v;
      }), r.d(t, "isNewEditorPlaybook", function () {
        return T;
      }), r.d(t, "isDriftEmailPlaybook", function () {
        return k;
      }), r.d(t, "isMarketplaceWebPlaybook", function () {
        return A;
      }), r.d(t, "isMeetingBookingPlaybook", function () {
        return O;
      });

      var y = function checkInReportTypes(e) {
        return function (t) {
          return t && e.includes(t.reportType);
        };
      },
          b = y(c),
          m = y(u),
          _ = y(s),
          v = y(p),
          h = y(a),
          g = y(i),
          T = function isNewEditorPlaybook(e) {
        return h(e) || g(e);
      },
          k = y(f),
          A = y(l),
          O = y(d);
    },
    4: function _(e, t) {
      e.exports = n;
    },
    48: function _(e, t, r) {
      var n = r(83);
      "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[e.i, n, ""]]);
      var o = {
        insert: "head",
        singleton: !1
      };
      r(14)(n, o);
      n.locals && (e.exports = n.locals);
    },
    5: function _(e, t, r) {
      "use strict";

      var n = r(16);

      function _slicedToArray(e, t) {
        return function _arrayWithHoles(e) {
          if (Array.isArray(e)) return e;
        }(e) || function _iterableToArrayLimit(e, t) {
          if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
            var r = [],
                n = !0,
                o = !1,
                a = void 0;

            try {
              for (var i, l = e[Symbol.iterator](); !(n = (i = l.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
                ;
              }
            } catch (u) {
              o = !0, a = u;
            } finally {
              try {
                n || null == l.return || l.return();
              } finally {
                if (o) throw a;
              }
            }

            return r;
          }
        }(e, t) || Object(n.a)(e, t) || function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }

      r.d(t, "a", function () {
        return _slicedToArray;
      });
    },
    50: function _(e, t, r) {
      "use strict";

      r.r(t), r.d(t, "PlaybookEditorUrlSubPath", function () {
        return n;
      }), r.d(t, "getPlaybookEditorUrlPath", function () {
        return i;
      }), r.d(t, "getPlaybookReportUrlPath", function () {
        return l;
      });
      var n,
          o = r(18),
          a = r(32);
      !function (e) {
        e.BOT_MESSAGE = "bot-message", e.BOT_FLOW = "visual-builder", e.DRIFT_LINK = "targeting/drift-link", e.EXPERIMENT = "visual-builder/experiment", e.FASTLANE_INSTALL = "install", e.FASTLANE_MAPPING = "form-mapping", e.SETTINGS = "settings", e.TARGETING = "targeting/builder";
      }(n || (n = {}));

      var i = function getPlaybookEditorUrlPath(e, t) {
        return e ? Object(a.isDriftEmailPlaybook)(e) ? "".concat(o.a.EMAIL_APP_URL, "/campaigns/editor/").concat(e.id, "/campaign-builder") : Object(a.isNewEditorPlaybook)(e) ? "/playbooks/editor/".concat(e.id).concat(t ? "/" + t : "") : "/playbooks/".concat(e.id, "/edit") : "";
      },
          l = function getPlaybookReportUrlPath(e) {
        return Object(a.isChatPlaybook)(e) || Object(a.isMeetingBookingPlaybook)(e) ? "/playbooks/chat/".concat(e.id) : Object(a.isFastlanePlaybook)(e) ? "/playbooks/fastlane/".concat(e.id) : Object(a.isMarketplaceWebPlaybook)(e) ? "/reports/playbooks/".concat(e.id) : i(e);
      };
    },
    51: function _(e, t) {
      e.exports = c;
    },
    54: function _(e, t, r) {
      "use strict";

      r.r(t);

      var n = r(51),
          o = r.n(n),
          a = r(22),
          i = function fetcher(e, t) {
        return a.a.get(e, {
          params: {
            state: "PUBLISHED",
            beforeTimeStamp: t
          }
        }).then(function (e) {
          return e.data;
        });
      };

      t.default = function usePlaybookVersionHistory(e, t) {
        return o()(["playbooks/".concat(e, "/versions"), t], i);
      };
    },
    6: function _(e, t, r) {
      "use strict";

      function _defineProperty(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }

      r.d(t, "a", function () {
        return _defineProperty;
      });
    },
    7: function _(e, t, r) {
      "use strict";

      r.d(t, "a", function () {
        return _objectSpread2;
      });
      var n = r(6);

      function ownKeys(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function _objectSpread2(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
            Object(n.a)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }
    },
    8: function _(e, t) {
      e.exports = o;
    },
    82: function _(e, t, r) {
      e.exports = r(141);
    },
    83: function _(e, t, r) {
      (t = e.exports = r(13)(!0)).push([e.i, ".styles_historyItem__ilBrT {\n  display: grid;\n  grid-template-columns: 1fr auto;\n}\n\n.styles_historyItem__ilBrT + .styles_historyItem__ilBrT {\n  margin-top: 16px;\n}\n\n.styles_historyItemByline__3J9UH {\n  margin: 0;\n}\n\n.styles_historyItemAction__2aTvx + .styles_historyItemAction__2aTvx {\n  margin-left: 8px;\n}\n", "", {
        version: 3,
        sources: ["styles.module.css"],
        names: [],
        mappings: "AAAA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB",
        file: "styles.module.css",
        sourcesContent: [".historyItem {\n  display: grid;\n  grid-template-columns: 1fr auto;\n}\n\n.historyItem + .historyItem {\n  margin-top: 16px;\n}\n\n.historyItemByline {\n  margin: 0;\n}\n\n.historyItemAction + .historyItemAction {\n  margin-left: 8px;\n}\n"]
      }]), t.locals = {
        historyItem: "styles_historyItem__ilBrT",
        historyItemByline: "styles_historyItemByline__3J9UH",
        historyItemAction: "styles_historyItemAction__2aTvx"
      };
    }
  });
});